"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundDown = exports.roundPayment = void 0;
const DECIMAL_PLACE_SHIFT = 100;
function roundPayment(value) {
    const roundable = value + Number.EPSILON;
    return Math.round(roundable * DECIMAL_PLACE_SHIFT) / DECIMAL_PLACE_SHIFT;
}
exports.roundPayment = roundPayment;
function roundDown(value) {
    return Math.floor(value * DECIMAL_PLACE_SHIFT) / DECIMAL_PLACE_SHIFT;
}
exports.roundDown = roundDown;
//# sourceMappingURL=payment-rounder.js.map